import { memo } from "react";

import { QuestionForMain } from "@/components/features/_layouts/island/main/question";

import { SingleImageField } from "@/components/ui/form/fields/image-field/single";

import { useVoucherKeyVisual } from "./use-key-visual";

type Props = {
	ownerID: string;
	resourceID: string;
};

export const QuestionVoucherKeyVisual = memo(({ ownerID, resourceID }: Props) => {
	const { rawMainKeyVisual, errorMessageMainKV, onSetMainKeyVisual } = useVoucherKeyVisual();

	return (
		<QuestionForMain
			required
			title={"キービジュアル"}
			guide={"推奨画像アスペクト比は16:9です。"}
			inputChildren={
				<div className="space-y-6">
					<SingleImageField
						image={rawMainKeyVisual}
						onInputImage={onSetMainKeyVisual}
						ownerID={ownerID}
						errorMessage={errorMessageMainKV}
						resourceID={resourceID}
					/>
				</div>
			}
		/>
	);
});

QuestionVoucherKeyVisual.displayName = "QuestionVoucherKeyVisual";
